import React, { useEffect, useState } from "react";
import "./Orders.css";
import Container from "react-bootstrap/Container";
import { Row, Card, Col, Form } from "react-bootstrap";
import Sidebar from "../../components/Sidebar/Sidebar";
import { OrderDetailsByID, UpdateOrderStatus } from "../../apis/OrderAPI";
import { Link, useSearchParams } from "react-router-dom";
import dateFormat from "dateformat";
import * as BsIcons from "react-icons/bs";
import { ShowOrderDocument } from "../../utils/Utility";
import { confirmAlert } from "react-confirm-alert";
import { useAlert } from "react-alert";
import { useSelector } from "react-redux";

export default function OrderDetail() {
  const alert = useAlert();
  const [searchParams] = useSearchParams();
  const orderid = searchParams.get("id");
  const { user } = useSelector((state) => state.auth);
  const [orderdata, setOrderData] = useState([]);
  const [attachments, setAttachments] = useState([]);
  const [reportData, setReportData] = useState([]);
  const [formDetail, setFormDetail] = useState([]);
  const [miscData, setMiscData] = useState([]);
  const [reportAttachments, setReportAttachments] = useState([]);
  const [isHtmlReport, setIsHtmlReport] = useState(true);

  async function GetOrderData() {
    var result = await OrderDetailsByID(orderid, "view");
    var data = result.data;
    setOrderData(data.item1);
    setMiscData(data.item2);
    setReportData(data.item3);
    setFormDetail(data.item5);
    let primaryReport = data.item3.filter((x) => x.is_primary);
    if (
      data.item3.length === 0 ||
      (primaryReport.length > 0 && primaryReport[0].report_template_id == 2)
    )
      setIsHtmlReport(false);
    var attachs = data.item4;
    setAttachments(attachs.filter((a) => a.attachment_type === "order"));
    setReportAttachments(attachs.filter((a) => a.attachment_type === "report"));
  }

  useEffect(() => {
    GetOrderData();
  }, []);

  const markComplete = () => {
    confirmAlert({
      title: "Order Complete",
      message:
        "Are you sure want to mark this order complete? You will not be able to make further changes in order",
      buttons: [
        {
          label: "Yes",
          className: "yesbtn",
          onClick: async () => {
            var result = await UpdateOrderStatus(orderid, "3", user.userid);
            if (result.status === 200){
              alert.success("Order completed successfully",{
                onClose: () => {
                  window.location.reload();
                }
              });
            }
            else alert.error("Unable to update order");
          },
        },
        {
          label: "No",
          className: "nobtn",
        },
      ],
    });
  };

  const reopenOrder = () => {
    confirmAlert({
      title: "Reopen Order",
      message: "Are you sure want to reopen this order?",
      buttons: [
        {
          label: "Yes",
          className: "yesbtn",
          onClick: async () => {
            var result = await UpdateOrderStatus(orderid, "13", user.userid);
            if (result.status === 200){
              alert.success("Order reopened successfully",{
                onClose: () => {
                  window.location.reload();
                }
              });
            }
            else alert.error("Unable to reopen order");
          },
        },
      ],
    });
  };

  return (
    <>
      <Container fluid>
        <Row>
          <div className="admin-wrapper">
            <div className="left-section">
              <Sidebar />
            </div>
            <div className="right-section">
              <Container fluid>
                <Row className="mt-5">
                  <Col lg={12} xs={12}>
                    <Card className="notifications-card">
                      <div className="card-head order-head">
                        <div className="card-title h5">Orders Details</div>
                        <Link to="/Admin/Orders" className="back-btn">
                          <BsIcons.BsArrowLeft />
                        </Link>
                      </div>
                      <Row className="detail-box">
                        <Col lg={6} md={12} className="mb-5">
                          <div className="cards-text">
                            <div className="cards-list-group">
                              <div className="cards-list-item">
                                <span>Order No:</span> {orderdata.order_id}
                              </div>
                              <div className="cards-list-item">
                                <span>Order Date:</span>{" "}
                                {dateFormat(
                                  orderdata.order_start_date,
                                  "mm/dd/yyyy"
                                )}
                              </div>
                              <div className="cards-list-item">
                                <span>Customer Name:</span>{" "}
                                {orderdata.customer_first_name}{" "}
                                {orderdata.customer_last_name}
                              </div>
                              <div className="cards-list-item">
                                <span>Customer No:</span>{" "}
                                {orderdata.customer_id}
                              </div>
                              <div className="cards-list-item">
                                <span>Requestor:</span>{" "}
                                {orderdata.requestor_first_name}{" "}
                                {orderdata.requestor_last_name}
                              </div>
                              <div className="cards-list-item">
                                <span>Requestor Address:</span>{" "}
                                {orderdata.requestor_address}
                              </div>
                              <div className="cards-list-item">
                                <span>Applicant:</span>{" "}
                                {orderdata.order_applicant_name}
                              </div>
                              <div className="cards-list-item">
                                <span>Co-Applicant:</span>{" "}
                                {orderdata.order_co_applicant}
                              </div>
                              <div className="cards-list-item">
                                <span>Address:</span> {orderdata.order_address}
                              </div>
                              <div className="cards-list-item">
                                <span>Due Date:</span>{" "}
                                {dateFormat(
                                  orderdata.order_end_date,
                                  "mm/dd/yyyy"
                                )}
                              </div>
                              <div className="cards-list-item">
                                <span>Completion Date:</span>{" "}
                                {orderdata.order_completion_date &&
                                  dateFormat(
                                    orderdata.order_completion_date,
                                    "mm/dd/yyyy"
                                  )}
                              </div>
                              <div className="cards-list-item">
                                <span>Prelim Report Date:</span>{" "}
                                {orderdata.order_prelim_report_date &&
                                  dateFormat(
                                    orderdata.order_prelim_report_date,
                                    "mm/dd/yyyy"
                                  )}
                              </div>
                              <div className="cards-list-item">
                                <span>Applicant Form:</span>{" "}
                                {formDetail.map((item) => (
                                  <p key={item.application_id}>
                                    <span>
                                      <Link
                                        to={`/Form?token=view&id=${item.form_id}&applicationid=${item.application_id}&custId=${orderdata.customer_id}`}
                                        target="_blank"
                                      >
                                        {item.form_name}
                                      </Link>
                                    </span>
                                  </p>
                                ))}
                              </div>
                              <div className="cards-list-item">
                                <span>Attachment(s):</span>
                                {attachments.map((item) => (
                                  <p key={item.order_attachment_id}>
                                    <span>
                                      <Link
                                        to={`?id=${orderid}`}
                                        onClick={() =>
                                          ShowOrderDocument(
                                            item.order_attachment_id
                                          )
                                        }
                                      >
                                        {item.attachment_name}
                                      </Link>
                                    </span>
                                  </p>
                                ))}
                              </div>

                              <div className="cards-list-item">
                                <span>Report Attachment(s):</span>
                                {reportAttachments.map((item) => (
                                  <p key={item.order_attachment_id}>
                                    <span>
                                      <Link
                                        to={`?id=${orderid}`}
                                        onClick={() =>
                                          ShowOrderDocument(
                                            item.order_attachment_id
                                          )
                                        }
                                      >
                                        {item.attachment_name}
                                      </Link>
                                    </span>
                                  </p>
                                ))}
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col lg={6} md={12} className="mb-5">
                          <div className="cards-text">
                            <div className="cards-list-group">
                              <div className="cards-list-item">
                                <span>Status:</span>{" "}
                                {orderdata.order_status_name}
                              </div>

                              <div className="cards-list-item">
                                <span>Billing Entity:</span>{" "}
                                {orderdata.billing_entity_name}
                              </div>
                              <div className="cards-list-item">
                                <span>Re/PO#:</span> {orderdata.order_po}
                              </div>
                              <div className="cards-list-item">
                                <span>References:</span> {orderdata.order_ref}
                              </div>
                              <div className="cards-list-item">
                                <span>Investigator:</span>{" "}
                                {orderdata.investigator_first_name}
                              </div>
                              <div className="cards-list-item">
                                <span>Report Type:</span>
                                {reportData.map((item) => (
                                  <p key={item.order_report_mapping_id}>
                                    {!item.is_primary ||
                                    item.report_template_id == 2 ? (
                                      item.report_name
                                    ) : (
                                      <Link
                                        to={`/Report?type=view&id=${item.order_report_mapping_id}`}
                                        target="_blank"
                                      >
                                        {item.report_name}
                                      </Link>
                                    )}{" "}
                                    - ${item.reportprice}
                                  </p>
                                ))}
                              </div>
                              <div className="cards-list-item">
                                <span>Report For:</span>
                                <div className="chkbx">
                                  <Form.Group
                                    controlId="ReportFor"
                                    className="mb-3"
                                  >
                                    <Form.Check
                                      type="checkbox"
                                      inline
                                      label="Individual"
                                      value="individual"
                                      checked={orderdata.individual}
                                      disabled
                                    />
                                    <Form.Check
                                      type="checkbox"
                                      inline
                                      label="Corporate"
                                      value="corporate"
                                      checked={orderdata.corporate}
                                      disabled
                                    />
                                    <Form.Check
                                      type="checkbox"
                                      inline
                                      label="Other"
                                      value="other"
                                      checked={orderdata.other}
                                      disabled
                                    />
                                    {orderdata.other && (
                                      <p>
                                        <span>Report Remark:</span>
                                        {orderdata.other_text}
                                      </p>
                                    )}
                                  </Form.Group>
                                </div>
                              </div>
                              <div className="cards-list-item">
                                <span>Miscellaneous Price:</span>
                                {miscData.map((item) => (
                                  <p key={item.misc_price_id}>
                                    {item.misc_note} - ${item.misc_price}
                                  </p>
                                ))}
                              </div>
                              <div className="cards-list-item">
                                <span>Tax Rate:</span>{" "}
                                {orderdata.tax_type == null
                                  ? ""
                                  : `${orderdata.tax_percentage}% (${orderdata.tax_type})`}
                              </div>
                              <div className="cards-list-item">
                                <span>Restriction:</span>{" "}
                                {orderdata.customer_restrictions}
                              </div>

                              <div className="cards-list-item">
                                <span>Customer Billing Information:</span>{" "}
                                {orderdata.order_billing_information}
                              </div>
                              <div className="cards-list-item">
                                <span>Other Instructions (from Customer):</span>{" "}
                                {orderdata.order_customer_instruction}
                              </div>
                              <div className="cards-list-item">
                                <span>Other Instructions (from Admin):</span>{" "}
                                {orderdata.order_admin_instruction}
                              </div>
                              <div className="cards-list-item">
                                <span>Need QA:</span>{" "}
                                <Form.Check
                                  type="checkbox"
                                  inline
                                  checked={orderdata.do_qa}
                                  disabled
                                />
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>

                      <Row className="order-buttons">
                        <Col
                          lg={6}
                          md={12}
                          className="mb-5 ordbtn disabled-btnnew"
                        >
                          <Link to={`/Admin/EditOrder?id=${orderid}`}>
                            <button
                              type="button"
                              className="gray-btn"
                              variant="success"
                              disabled={
                                orderdata.order_status_id === 1 ||
                                orderdata.order_status_id === 6 ||
                                orderdata.order_status_id === 8
                                  ? false
                                  : true
                              }
                            >
                              {orderdata.order_status_id === 1
                                ? "Assign & Edit Order"
                                : "Edit Order"}
                            </button>
                          </Link>
                        </Col>
                        {orderdata.reopen == 1 &&
                        isHtmlReport &&
                        !orderdata.other ? (
                          <Col
                            lg={6}
                            md={12}
                            className="mb-5 ordbtn disabled-btnnew"
                          >
                            <button
                              type="button"
                              className="blue-btn"
                              onClick={reopenOrder}
                              disabled={orderdata.order_status_id == 13}
                            >
                              Reopen Order
                            </button>
                          </Col>
                        ) : (
                          <Col
                            lg={6}
                            md={12}
                            className="mb-5 ordbtn disabled-btnnew"
                          >
                            <button
                              type="button"
                              className="blue-btn"
                              onClick={markComplete}
                              disabled={
                                ((orderdata.order_status_id === 12 ||
                                  (!orderdata.do_qa &&
                                    orderdata.order_status_id === 7)) &&
                                  (attachments.length > 0 ||
                                    reportData.length > 0)) ||
                                orderdata.other
                                  ? false
                                  : true
                              }
                            >
                              Mark Complete
                            </button>
                          </Col>
                        )}
                      </Row>
                    </Card>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
}
